import {EntitiesProperties} from "../../../utils/enums";
import {DynamicDatagrid, Grid, Paper, Typography, GridColDef, GridRenderCellParams} from "@leap4/frontend";
import {ISupplyTagData} from "../../../interfaces/IOverviewData";

export interface ITagsTableProps {
    tagsData: ISupplyTagData[],
    loading: boolean,
    refreshFunc: () => void;
}

interface ISpentByDateRow {
    id: string;
    date: string;
    spent: number;
    impressions: number;
    requests: number;
}

export const TagsTable = ({tagsData, loading, refreshFunc} : ITagsTableProps): JSX.Element => {
    const align = 'left'
    const {REQUESTS, SPENT, IMPRESSIONS} = EntitiesProperties.NUMERIC.ALL
    const formatCurrency = (value: number) => `$${(value || 0).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
    const columns: GridColDef[] = [
        {
            field: 'date',
            headerName: 'Date',
            type:'string',
            width: 150,
            renderCell: (params: GridRenderCellParams) => {
                return new Date(params.value).toLocaleDateString("he")
            },

        },
        {
            field: SPENT,
            headerName: 'Spent',
            type: 'number',
            width: 100,
            align,
            headerAlign: align,
            renderCell: (params) => {
                return formatCurrency(params.value)
            }
        },
        {
            field: IMPRESSIONS,
            headerName: 'Impressions',
            type: 'number',
            width: 160,
            align,
            headerAlign: align,
            renderCell: (params) => {
                return params.value.toLocaleString()
            }
        },
        {
            field: REQUESTS,
            headerName: 'Requests',
            type: 'number',
            width: 180,
            align,
            headerAlign: align,
            renderCell: (params) => {
                return params.value?.toLocaleString()
            }
        },
    ];


    function createRowsByDate(items: ISupplyTagData[] = []): ISpentByDateRow[] {
        const rowsByDate = items.reduce<Record<string, ISpentByDateRow>>((acc, item: any) => {
            const date = item.date;
            if (!acc[date]) {
                acc[date] = {
                    id: date,
                    date,
                    spent: 0,
                    impressions: 0,
                    requests: 0
                }
            }

            acc[date].spent += item.spent ?? item.cost ?? 0;
            acc[date].impressions += item.impressions || 0;
            acc[date].requests += item.requests || 0;
            return acc;
        }, {});

        return Object.values(rowsByDate);
    }

    const tagsRows = createRowsByDate(tagsData)
        .sort((a,b)=>new Date(b.date).getTime()-new Date(a.date).getTime())

    return (
        <>
            <Grid container justifyContent={"space-around"}>
                <Grid size={12}>
                    <Typography variant={"overline"}>Demand Tags</Typography>
                    <Paper elevation={5} style={{borderRadius: "16px"}}>
                        <DynamicDatagrid rows={tagsRows}
                                         columns={columns}
                                         loading={loading}
                                         loadError={false}
                                         refreshFunc={refreshFunc}
                                         pageSize={100}
                                         style={{minHeight: `75vh`, width: '100%'}}
                        />
                    </Paper>
                </Grid>
            </Grid>
        </>
    );

}
